<template>
  <v-flex>
    <v-dialog v-model="dialogFormularioReserva" width="1400px" persistent>
      <reserva-formulario :modelReserva="this.modelReserva" :accion="this.accion"
        @cerrarFormularioReserva="_actualizarDatos" @cerrar="dialogFormularioReserva = false" />
    </v-dialog>

    <v-dialog v-model="showConfirmacionEliminacion" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showConfirmacionEliminacion = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar la reserva?
            </v-label>
          </v-row>

          <v-row class="mt-8 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarReserva()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacion = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense color="blue-grey darken-2" flat>
        <v-toolbar-title :dark="!dark">Reservas</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
       <!-- <v-chip label class="ml-4" @click="mostrarbusqueda = !mostrarbusqueda" :color="colorAccent1">
          <span>Búsqueda</span>
        </v-chip> -->
        <v-spacer></v-spacer>

        <v-chip label class="mr-1" :color="colorAccent1" @click="_actualizar()">
          <span>Actualizar</span>
        </v-chip>

        <v-chip label class="mr-1" link :color="colorAccent1" @click="_crearReserva()">
          <span v-bind:style="{ color: 'white' }">Nueva Reserva</span>
        </v-chip>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <v-col class="mr-8" cols="3" align="start">
            <v-menu :dark="dark" v-model="date1" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field :dark="dark" clearable dense outlined v-model="busquedaDesde" label="Desde"
                  prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker :dark="dark" color="success" locale="es" v-model="busquedaDesde" @input="date1 = false"
                first-day-of-week="1"></v-date-picker>
            </v-menu>

            <v-menu :dark="dark" v-model="date2" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field :dark="dark" clearable dense outlined v-model="busquedaHasta" label="Hasta"
                  prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker :dark="dark" color="success" locale="es" v-model="busquedaHasta" @input="date2 = false"
                first-day-of-week="1"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="3" align="start">
            <v-text-field :dark="dark" clearable outlined v-model="busquedaCodigo" autocomplete="off"
              label="Busqueda por número" placeholder="Código del presupuesto..." @keyup.enter="_getReservas"
              dense></v-text-field>

            <v-text-field :dark="dark" clearable outlined v-model="busquedaAgencia" autocomplete="off"
              label="Busqueda por código agencia" placeholder="Código agencia..." @keyup.enter="_getReservas"
              dense></v-text-field>


            <v-text-field :dark="dark" clearable outlined v-model="busquedaCliente" autocomplete="off"
              label="Busqueda por cliente" placeholder="Nombre, Teléfono, email..." @keyup.enter="_getReservas"
              dense></v-text-field>

            <v-select class="mt-0 mr-0" :items="estadosFiltro" label="Búsqueda por estado" dense :dark="dark" outlined
              v-model="busquedaEstado" item-text="estado" return-object> </v-select>
          </v-col>


        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col>
          <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="ma-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>
        <v-row v-if="reservas" class="mt-0" justify="start" dense>
          <v-col cols="12" align="center">
            <v-data-table locale="es" v-if="reservas" dense :headers="headers" :items="reservas"
            :server-items-length="totalReservas" :options.sync="options" must-sort
              class="elevation-1 alternating-rows bordered-table" :footer-props="{
                'items-per-page-options': [20, 50, 100],
                'items-per-page-text': 'Reservas por página',
              }" @update:options="handleUpdateOptions">
              <template v-slot:body.prepend>
                <tr class="tabla-filtros-row">
                  <td>
                    <v-text-field
                      v-model="filtrosTabla.codigo_reserva"
                      dense
                      outlined
                      clearable
                      hide-details
                      placeholder="Cod. res."
                      class="tabla-filtro-input"
                      @click:clear="onFiltroClear"
                      @keyup.enter="onBuscar"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="busquedaCodigo"
                      dense
                      outlined
                      clearable
                      hide-details
                      placeholder="Cod. pre."
                      class="tabla-filtro-input"
                      @click:clear="onFiltroClear"
                      @keyup.enter="onBuscar"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="filtrosTabla.fecha_inicio"
                      dense
                      outlined
                      clearable
                      hide-details
                      placeholder="Fecha inicio"
                      class="tabla-filtro-input"
                      @click:clear="onFiltroClear"
                      @keyup.enter="onBuscar"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="busquedaCliente"
                      dense
                      outlined
                      clearable
                      hide-details
                      placeholder="Cliente"
                      class="tabla-filtro-input"
                      @click:clear="onFiltroClear"
                      @keyup.enter="onBuscar"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="filtrosTabla.created_at"
                      dense
                      outlined
                      clearable
                      hide-details
                      placeholder="Solicitud"
                      class="tabla-filtro-input"
                      @click:clear="onFiltroClear"
                      @keyup.enter="onBuscar"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="filtrosTabla.origen"
                      dense
                      outlined
                      clearable
                      hide-details
                      placeholder="Origen"
                      class="tabla-filtro-input"
                      @click:clear="onFiltroClear"
                      @keyup.enter="onBuscar"
                    />
                  </td>
                  <td>
                    <v-select
                      v-model="filtrosTabla.language"
                      :items="idiomasFiltro"
                      dense
                      outlined
                      clearable
                      hide-details
                      placeholder=""
                      class="tabla-filtro-input"
                      @click:clear="onFiltroClear"
                      @change="onBuscar"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="filtrosTabla.cant_peregrinos"
                      dense
                      outlined
                      clearable
                      hide-details
                      placeholder="Pil"
                      class="tabla-filtro-input"
                      @click:clear="onFiltroClear"
                      @keyup.enter="onBuscar"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="filtrosTabla.cant_habitaciones"
                      dense
                      outlined
                      clearable
                      hide-details
                      placeholder="Hab"
                      class="tabla-filtro-input"
                      @click:clear="onFiltroClear"
                      @keyup.enter="onBuscar"
                    />
                  </td>
                  <td>
                   <!-- <v-text-field
                      v-model="filtrosTabla.comentarios"
                      dense
                      outlined
                      clearable
                      hide-details
                      placeholder="Comentarios"
                      class="tabla-filtro-input"
                      @click:clear="onFiltroClear"
                      @keyup.enter="onBuscar"
                    /> -->
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <v-select
                      v-model="busquedaEstado"
                      :items="estadosFiltro"
                      item-text="estado"
                      return-object
                      dense
                      outlined
                      clearable
                      hide-details
                      placeholder="Estado"
                      class="tabla-filtro-input"
                      @click:clear="onFiltroClear"
                      @change="onBuscar"
                    />
                  </td>
                  <td></td>
                </tr>
              </template>

              <template v-slot:[`item.codigo_reserva`]="{ item }">
                <div class="text-center" :style="{ backgroundColor: _getEstadoColorReserva(item) }"> {{ item.codigo_reserva }} </div>
              </template>

              <template v-slot:[`item.fechas`]="{ item }">
                <div class="fechas-container">
                  <div class="fecha-inicio">{{ formatearFecha(item.fecha_inicio) }}</div>
                  <div class="fecha-llegada">{{ formatearFecha(item.fecha_llegada) }}</div>
                </div>
              </template>


              <template v-slot:[`item.cliente_camino`]="{ item }">
                <div>
                  <div class="font-weight-medium">
                    {{ getReservaClienteTexto(item) }}
                    <v-icon v-if="item.es_cliente" color="orange" small class="ml-1">mdi-star</v-icon>
                  </div>
                  <div class="subtitle-2 grey--text">{{ getReservaCaminoTexto(item) }}</div>
                </div>
              </template>

              <template v-slot:[`item.created_at`]="{ item }">
                {{ formatearFechaConHora(item.created_at) }}
              </template>

              <template v-slot:[`item.cant_peregrinos`]="{ item }">
                <div>
                  <div class="font-weight-medium">{{ item.cant_peregrinos }}</div>

                </div>
              </template>

             
                <template v-slot:[`item.cant_habitaciones`]="{ on, item }" >
                  <div class="habitaciones-icon">
                    <v-icon size="28" :color="'rgb(100, 100, 100, 1)'" v-on="on">mdi-bed
                    </v-icon>
                    <span class="habitaciones-count">{{ item.cant_habitaciones }}</span>
                  </div>
                </template>
                

              




              <template v-slot:[`item.etapas_chips`]="{ item }">
                <div>
                  <v-chip class="px-2 fixed-width-chip" small label :color="_getColorEstadoEnProceso()"
                    text-color="black">
                    {{ item.etapas_en_proceso }}
                  </v-chip>
                  <v-chip class="px-2 mr-1 ml-1 fixed-width-chip" small label :color="_getColorEstadoConfirmada()"
                    text-color="black">
                    {{ item.etapas_confirmadas }}
                  </v-chip>
                  
                </div>
              </template>

              <!--   <template v-slot:[`item.action`]="{ item }">
                <v-chip class="mr-1" label small :color="colorAccent3" text-color="white" link @click="_editar(item)">
                  Editar
                </v-chip>

                <v-chip label small color="red lighten-2" text-color="white" link @click="_delete(item)">
                  Eliminar
                </v-chip>
              </template> -->

              <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="_editarReserva(item)">
                      <v-list-item-title>Editar</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="_deleteReserva(item)">
                      <v-list-item-title>Eliminar</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="getReservaEstadoTexto(item) == 'SOLICITADA'" @click="_enviarPresupuesto(item)">
                      <v-list-item-title>Enviar Presupuesto</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="getReservaEstadoTexto(item) == 'PRESUPUESTADA'" @click="_pagoPresupuesto(item)">
                      <v-list-item-title>Pago Presupuesto</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>

              <template v-slot:no-data>
                No hay datos disponibles
              </template>


            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import ReservaFormulario from "../components/formularios/ReservaFormulario.vue";
import {
  getReservaCaminoTitulo,
  getReservaClienteNombre,
  getReservaEstadoColor,
  getReservaEstadoNombre,
} from "@/helpers/reservaHelpers";
/*import Echo from "laravel-echo";

window.Pusher = require("pusher-js");*/

export default {
  components: {
    ReservaFormulario,
  },

  data: () => ({
    dialogFormularioReserva: false,
    dialogReservaUpdate: false,
    accion: "",

    headers: [
      // { text: "ID", width: "80px", align: "left", sortable: false, value: "id" },
      { text: 'COD_RES', value: 'codigo_reserva', sortable: true, width: '100px' },
      { text: 'COD_PRE', value: 'codigo', sortable: true, width: '100px' },
      { text: "FECHAS", align: "left", sortable: true, value: "fechas", width: "160px" },

      { text: "CLIENTE / CAMINO", align: "left", sortable: true, value: "cliente_camino" },
      { text: "FECHA CREADA", align: "left", sortable: true, value: "created_at" },
      { text: "ORIGEN", align: "left", sortable: true, value: "origen.nombre" },
      { text: "IDIOMA", align: "center", sortable: true, value: "language", width: "20px" },
      
      { text: "PEREG.", align: "center", sortable: true, value: "cant_peregrinos", width: "35px" },
      { text: "HAB", align: "center", sortable: true, value: "cant_habitaciones", width: "35px" },
      { text: "COMENTARIOS", align: "left", sortable: true, value: "comentarios" },
      { text: "CREADO", align: "center", sortable: false, value: "creada_por.inicial", width: "20px" },
      { text: "ASIG.", align: "center", sortable: false, value: "asignada_a.inicial", width: "20px" },
      
      { text: "ETAPAS", align: "center", sortable: false, value: "etapas_chips", width: "150px" },
      { text: "", width: "10px", value: "actions", sortable: false, align: "center" },
    ],

    checkSoloAccion: true,

    mostrarbusqueda: false,
    date1: false,
    date2: false,

    busquedaDesde: new Date().toISOString().substr(0, 10),
    busquedaHasta: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
    fechaEntre: [new Date().toISOString().substr(0, 10), new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10)],


    busquedaCliente: "",
    busquedaAgencia: null,
    busquedaCodigo: null,

    modelReserva: null,
    editando: false,

    showConfirmacionEliminacion: false,

    reservaEnviando: null,
    enviando: false,

    busquedaEstado: null,
    idiomasFiltro: ["ES", "EN", "DE"],
    filtrosTabla: {
      codigo_reserva: "",
      fecha_inicio: "",
      created_at: "",
      origen: "",
      language: "",
      cant_peregrinos: "",
      cant_habitaciones: "",
      comentarios: "",
    },

    options: {
      page: 1,
      itemsPerPage: 20,
      sortBy: ["codigo_reserva"],
      sortDesc: [true],
    },
    currentPage: 1,
    itemsPerPage: 20,
    lastOptionsSignature: "",
    restableciendoFiltros: false,


  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",
      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",
      "colorAccent1",

      "colorAccent2",
      "colorAccent1",
      "colorAccent3",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("estados", ["estados"]),
    ...mapState("reservas", ["reservas", "reservaSelec", "totalReservas"]),
    ...mapGetters("estados", ["getEstadoIdEnProceso", "getEstadoIdConfirmada", "getEstadoIdConfirmacionFinal"]),

    estadosFiltro() {
      const indiceEnProceso = this.estados.findIndex(({ estado }) => estado === "EN PROCESO");
      return indiceEnProceso === -1 ? [] : this.estados.slice(indiceEnProceso);
    },

    reservasFiltradas() {
      return this.reservas.filter(
        (r) => this.getReservaEstadoTexto(r) != "PRESUPUESTADA"
      );

    },

    esAgenciaFiltro() {
      return String(this.$route?.query?.es_agencia || "0") === "1" ? 1 : 0;
    },

    /*  proveedores() {
        if (this.reservas.length > 0) {
          return this.reservas[0].proveedores;
        }
      }*/
  },

  watch: {
    "$route.query.es_agencia"(value, oldValue) {
      const nuevoValor = String(value || "0");
      const valorAnterior = String(oldValue || "0");

      if (nuevoValor !== valorAnterior) {
        this.currentPage = 1;
        this.options = this.normalizeTableOptions({ ...this.options, page: 1 });
        this.lastOptionsSignature = this.buildOptionsSignature(this.options);
        this._getReservas(true);
      }
    },


    busquedaDesde(value) {
      if (this.restableciendoFiltros) return;

      if (value != null && this.busquedaHasta != null) {
        this.fechaEntre[0] = value;
        this.fechaEntre[1] = this.busquedaHasta;
        this._getReservas(true);
      } else {
        this.fechaEntre[0] = null;
        this.fechaEntre[1] = null;
      }
    },

    busquedaHasta(value) {
      if (this.restableciendoFiltros) return;

      if (value != null && this.busquedaDesde != null) {
        this.fechaEntre[0] = this.busquedaDesde;
        this.fechaEntre[1] = value;
        this._getReservas(true);
      } else {
        this.fechaEntre[0] = null;
        this.fechaEntre[1] = null;
      }
    },
  },

  mounted() {
    this.options = this.normalizeTableOptions(this.options);
    this.lastOptionsSignature = this.buildOptionsSignature(this.options);
    this._getReservas(true);

  },

  methods: {
    ...mapActions("reservas", ["getReservas", "eliminarReserva", "envioPresupuesto", "pagoPresupuesto", "envioCorreos"]),

    ...mapMutations("reservas", [
      "setDialogWidth",
      "setRutaSelec",
      "setFechaSelec",
      "setReservaSelec",
    ]),
    ...mapMutations("infoDiario", ["setDiarioFechaSelec"]),



    activarListen() {
      /* try {
         if (window && window.Echo) {
           window.Echo.channel("ActChannel").stopListening("Actualizacion");
         }
        window.Echo = new Echo({
           broadcaster: "pusher",
           key: "98e959a1813dde0d7466",
           cluster: "eu",
           forceTLS: false,
         });
         window.Echo.channel("reserva-channel").listen("change-reserva", (e) => {
           alert('Entro a actualizar:');
           if (e.action === "ActReserva") {
             this.actualizarReserva(e.data.reserva_id);
           } else if (e.action === "ActEstado") {
             this.actPusherEstadoListReservas(e.data);
           } else {
             this._getReservas(false);
           }
         });
       } finally {
       }*/
    },

    normalizeTableOptions(options = {}) {
      const sortBy = Array.isArray(options.sortBy)
        ? options.sortBy
        : options.sortBy
          ? [options.sortBy]
          : [];
      const sortDesc = Array.isArray(options.sortDesc)
        ? options.sortDesc
        : typeof options.sortDesc === "boolean"
          ? [options.sortDesc]
          : [];

      return {
        ...this.options,
        ...options,
        page: options.page || 1,
        itemsPerPage: options.itemsPerPage || 20,
        sortBy,
        sortDesc,
      };
    },

    buildOptionsSignature(options = {}) {
      const normalizedOptions = this.normalizeTableOptions(options);

      return JSON.stringify({
        page: normalizedOptions.page,
        itemsPerPage: normalizedOptions.itemsPerPage,
        sortBy: normalizedOptions.sortBy[0] || null,
        sortDesc: normalizedOptions.sortDesc[0] ?? null,
      });
    },

    handleUpdateOptions(newOptions) {
      const normalizedOptions = this.normalizeTableOptions(newOptions);
      const nextSignature = this.buildOptionsSignature(normalizedOptions);

      if (nextSignature === this.lastOptionsSignature) {
        return;
      }

      this.options = normalizedOptions;
      this.currentPage = normalizedOptions.page;
      this.itemsPerPage = normalizedOptions.itemsPerPage;
      this.lastOptionsSignature = nextSignature;

      this._getReservas(true);
    },

    getApiSortField(sortBy) {
      const sortMap = {
        fechas: "fecha_inicio",
        cliente_camino: "cliente",
        "origen.nombre": "origen",
      };

      return sortMap[sortBy] || sortBy;
    },

    onBuscar() {
      this.currentPage = 1;
      this.options = this.normalizeTableOptions({ ...this.options, page: 1 });
      this.lastOptionsSignature = this.buildOptionsSignature(this.options);
      this._getReservas(true);
    },

    async onFiltroClear() {
      await this.$nextTick();
      this.onBuscar();
    },

    formatearFecha(fecha) {
      if (!fecha) return '';
      const [year, month, day] = fecha.split('-');
      const diaSemana = this.obtenerDiaSemana(fecha);
      return `${day}/${month}/${year} (${diaSemana})`;
    },

    obtenerDiaSemana(fecha) {
      const dias = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
      const date = new Date(fecha);
      return dias[date.getDay()];
    },

    async _actualizar() {
      const hoy = new Date().toISOString().substr(0, 10);
      const hasta = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10);

      this.restableciendoFiltros = true;
      this.date1 = false;
      this.date2 = false;
      this.busquedaDesde = hoy;
      this.busquedaHasta = hasta;
      this.fechaEntre = [hoy, hasta];
      this.busquedaCliente = "";
      this.busquedaAgencia = null;
      this.busquedaCodigo = null;
      this.busquedaEstado = null;
      this.filtrosTabla = {
        codigo_reserva: "",
        fecha_inicio: "",
        created_at: "",
        origen: "",
        language: "",
        cant_peregrinos: "",
        cant_habitaciones: "",
        comentarios: "",
      };
      this.currentPage = 1;
      this.itemsPerPage = 20;
      this.options = this.normalizeTableOptions({
        page: 1,
        itemsPerPage: 20,
        sortBy: ["codigo_reserva"],
        sortDesc: [true],
      });
      this.lastOptionsSignature = this.buildOptionsSignature(this.options);
      await this.$nextTick();
      this.restableciendoFiltros = false;
      this._getReservas(true);
    },

    _tooltipAlojamiento(etapa) {
      var res = "";
      etapa.proveedores.forEach(prov => {
        res = res + prov.nombre + "\n";
      });
      return res;
    },

    getReservaClienteTexto(reserva) {
      return getReservaClienteNombre(reserva);
    },

    getReservaCaminoTexto(reserva) {
      return getReservaCaminoTitulo(reserva);
    },

    getReservaEstadoTexto(reserva) {
      return getReservaEstadoNombre(reserva);
    },

    _getEstadoColorReserva(reserva) {
      return getReservaEstadoColor(reserva);
    },

    async _enviarPresupuesto(reserva) {
      this.enviando = true;
      this.reservaEnviando = reserva.id;
      let res = await this.envioPresupuesto([this.access_token, reserva.id]);
      this.enviando = false;
      this.reservaEnviando = null;
      // this.envioCorreos([this.access_token]);
    },

    async _pagoPresupuesto(reserva) {
      this.enviando = true;
      this.reservaEnviando = reserva.id;
      let res = await this.pagoPresupuesto([this.access_token, reserva.id]);
      this.enviando = false;
      this.reservaEnviando = null;
      // this.envioCorreos([this.access_token]);
    },




    _getColorEstado(reserva) {
      return getReservaEstadoColor(reserva);
    },

    _getEtapasConfirmadas(reserva) {
      if (!reserva.etapas || !Array.isArray(reserva.etapas)) {
        return 0;
      }

      return reserva.etapas.reduce((completadas, etapa) => {
        const etapaCompletada = etapa.proveedores &&
          Array.isArray(etapa.proveedores) &&
          etapa.proveedores.some(prov => prov.estado_id === this.getEstadoIdConfirmada());

        return completadas + (etapaCompletada ? 1 : 0);
      }, 0);
    },


    _getEtapasEnProceso(reserva) {
      if (!reserva.etapas || !Array.isArray(reserva.etapas)) {
        return 0;
      }
      return reserva.etapas.reduce((pendientes, etapa) => {
        const etapaPendiente = etapa.proveedores &&
          Array.isArray(etapa.proveedores) &&
          etapa.proveedores.some(prov => prov.estado_id === this.getEstadoIdEnProceso());

        return pendientes + (etapaPendiente ? 1 : 0);
      }, 0);
    },

    _getEtapasCanceladas(reserva) {
      if (!reserva.etapas || !Array.isArray(reserva.etapas)) {
        return 0;
      }
      return reserva.etapas.reduce((canceladas, etapa) => {
        const etapaCancelada = etapa.proveedores &&
          Array.isArray(etapa.proveedores) &&
          etapa.proveedores.length > 0 &&
          etapa.proveedores.every(prov => prov.estado_id === this.getEstadoIdEnProceso());

        return canceladas + (etapaCancelada ? 1 : 0);
      }, 0);
    },





    _getColorEstadoConfirmada() {
      const est = this.estados.findIndex(r => r.id === this.getEstadoIdConfirmada);
      return this.estados[est].color;
    },


    _getColorEstadoEnProceso() {
      const est = this.estados.findIndex(r => r.id === this.getEstadoIdEnProceso);
      return this.estados[est].color;
    },

    _getColorEstadoCancelada() {
      return '#F44336';
    },

    _getColorEstadoEtapa(etapa) {
      let res = "#FFFFFF";

      const allCanceled = etapa.proveedores.every(prov => prov.estado_id === this.getEstadoIdEnProceso());
      if (allCanceled) {
        const est = this.estados.findIndex(r => r.id === this.getEstadoIdEnProceso());
        return this.estados[est].color;
      }

      const someCompleted = etapa.proveedores.some(prov => prov.estado_id === this.getEstadoIdConfirmada());
      if (someCompleted) {
        const est = this.estados.findIndex(r => r.id === this.getEstadoIdConfirmada());
        return this.estados[est].color;
      }

      const isPending = etapa.proveedores.some(prov => prov.estado_id === this.getEstadoIdEnProceso());
      if (isPending) {
        const est = this.estados.findIndex(r => r.id === this.getEstadoIdEnProceso());
        return this.estados[est].color;
      }

      return res;
    },

    _colorEstadoAlojamiento(aloj) {
      const est = this.estados.findIndex(e => e.id === aloj.estado_id);
      return this.estados[est].color;
    },

    _tieneAlojamientosCancelados(etapa) {
      const allCanceled = etapa.proveedores.every(prov => prov.estado_id === this.getEstadoIdEnProceso());
      const someCanceled = etapa.proveedores.some(prov => prov.estado_id === this.getEstadoIdEnProceso());

      let res = "#FFFFFF";

      if (!allCanceled && someCanceled) {
        const est = this.estados.findIndex(r => r.id === this.getEstadoIdEnProceso());
        res = this.estados[est].color;
      }
      return res;
    },


    _deleteReserva(item) {
      this.setReservaSelec(item);
      this.showConfirmacionEliminacion = true;
    },

    async _eliminarReserva() {
      this.showConfirmacionEliminacion = false;
      if (this.reservaSelec != null) {
        await this.eliminarReserva([
          this.access_token,
          this.reservaSelec.id.toString(),
        ]);

        this._getReservas(true);
      }
    },




    _imprimir() { },

    _captionRangoFechas(fecha_inicio, fecha_llegada) {
      return fecha_inicio.split("-")[2] + '/' + fecha_inicio.split("-")[1] + " - "
        + fecha_llegada.split("-")[2] + '/' + fecha_llegada.split("-")[1];
    },


    _captionFecha(fecha, con_diasemana) {
      if (fecha) {
        return (

          fecha.substring(8, 10) +
          "-" +
          fecha.substring(5, 7) +
          "-" +
          fecha.substring(0, 4) +
          (con_diasemana ? " (" + this._diasemana(fecha) + ")" : "")
        );
      } else {
        return "";
      }
    },

    _diasemana(date) {
      let days = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
      let d = new Date(date.substring(0, 10));
      let dd = d.getUTCDay();
      if (dd > 0) {
        return days[d.getUTCDay() - 1];
      } else {
        return days[6];
      }
    },

    _actualizarDatos() {
      this.dialogFormularioReserva = false;
      this._getReservas(false);
    },

    _crearReserva() {
      //this._inicializarModelReserva();
      //this.accion = "crear";
      //this.dialogFormularioReserva = true;
      this.$router.push({
        path: "/Presupuestos/0",
        query: {
          es_agencia: String(this.esAgenciaFiltro),
          tipo: "RESERVA",
          estado_id: "3",
        },
      });
    },

    _editarReserva(reserva) {
      /*this.setReservaSelec(reserva);
      let temp = JSON.parse(JSON.stringify(this.reservaSelec));
      this.modelReserva = temp;
      this.accion = "editar";
      this.dialogFormularioReserva = true;*/
      if (reserva && reserva.id) {
        this.$router.push({
          path: "/Presupuestos/" + reserva.id,
          query: {
            es_agencia: String(this.esAgenciaFiltro),
            tipo: "RESERVA",
          },
        });
      }
    },

    async _getReservas(showload) {
      const params = {};
      const sortBy = Array.isArray(this.options.sortBy) ? this.options.sortBy[0] : this.options.sortBy;
      const sortDesc = Array.isArray(this.options.sortDesc) ? this.options.sortDesc[0] : this.options.sortDesc;
      const apiSortBy = this.getApiSortField(sortBy);
      
      params.page = this.options.page || this.currentPage;
      params.per_page = this.options.itemsPerPage || this.itemsPerPage;

      if (apiSortBy) {
        params.sort_by = apiSortBy;
        params.sort_direction = sortDesc ? "desc" : "asc";
      }

      if (this.fechaEntre[0] && this.fechaEntre[1]) {
        params.fechaEntre = this.fechaEntre;
      }

      if (this.busquedaCliente && this.busquedaCliente != "") {
        params.cliente = this.busquedaCliente;
      }
      if (this.busquedaCodigo && this.busquedaCodigo != "") {
        params.codigo = this.busquedaCodigo;
      }
      if (this.busquedaAgencia && this.busquedaAgencia != "") {
        params.codigo_agencia = this.busquedaAgencia;
      }
      if (this.filtrosTabla.codigo_reserva) {
        params.codigo_reserva = this.filtrosTabla.codigo_reserva;
      }
      if (this.filtrosTabla.fecha_inicio) {
        params.fecha_inicio = this.filtrosTabla.fecha_inicio;
      }
      if (this.filtrosTabla.created_at) {
        params.created_at = this.filtrosTabla.created_at;
      }
      if (this.filtrosTabla.origen) {
        params.origen = this.filtrosTabla.origen;
      }
      if (this.filtrosTabla.language) {
        params.language = this.filtrosTabla.language;
      }
      if (this.filtrosTabla.cant_peregrinos) {
        params.cant_peregrinos = this.filtrosTabla.cant_peregrinos;
      }
      if (this.filtrosTabla.cant_habitaciones) {
        params.cant_habitaciones = this.filtrosTabla.cant_habitaciones;
      }
      if (this.filtrosTabla.comentarios) {
        params.comentarios = this.filtrosTabla.comentarios;
      }
      if (this.busquedaEstado && this.busquedaEstado.id) {
        params.estado = this.busquedaEstado.id;
      }
      params.es_agencia = this.esAgenciaFiltro;
      await this.getReservas([this.access_token, params, showload]);
    
    },

    _limpiarfiltros() {
      this.busquedaDesde = null;
      this.busquedaHasta = null;
      this.busquedaCliente = "";
      this.busquedaAgencia = null;
      this.busquedaCodigo = null;
      this.filtrosTabla = {
        codigo_reserva: "",
        fecha_inicio: "",
        created_at: "",
        origen: "",
        language: "",
        cant_peregrinos: "",
        cant_habitaciones: "",
        comentarios: "",
      };
      this._getReservas(true);
    },

    toggle(fecha) {
      this.reservas.forEach((reserva) => {
        if (reserva.fecha === fecha) {
          reserva.hide = !reserva.hide;
        }
      });
    },

    _inicializarModelReserva() {
      this.modelReserva = {
        id: null,
        camino: null,
        cliente: {
          id: null,
          tipoCliente: null,
          nombre: null,
          apellidos: null,
          telefono: null,
          email: null,
          documento: null,
          direccion: null,
          comentarios: null,
        },
        etapas: [],
        fecha_inicio: null,
        fecha_llegada: null,
        cant_habitaciones_individuales: 0,
        cant_habitaciones_dobles: 0,
        cant_habitaciones_dobles_matrimoniales: 0,
        cant_habitaciones_triples: 0,
        cant_habitaciones_cuadruples: 0,
        cant_peregrinos: 0,
        estado: null,
        origen: null,
        comentarios: null,
        importe_presupuestado: 0,
        descripcion_importe_presupuestado: null,
        language: 'ES',

      };
    },

    formatearFechaConHora(fecha) {
      if (!fecha) return '';

      const date = new Date(fecha);

      if (Number.isNaN(date.getTime())) {
        return fecha; 
      }

      const dia = String(date.getDate()).padStart(2, '0');
      const mes = String(date.getMonth() + 1).padStart(2, '0');
      const año = date.getFullYear();
      const hora = String(date.getHours()).padStart(2, '0');
      const minutos = String(date.getMinutes()).padStart(2, '0');

      return `${dia}/${mes}/${año} ${hora}:${minutos}`;
    },
  },
};
</script>

<style scoped>
.squared-chip {
  border-radius: 0 !important;
}

.alternating-rows>>>tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}

.fixed-width-chip {
  width: 30px !important;
  justify-content: center;
}

.v-chip.v-size--small {
  height: 24px;
}

.v-chip.v-size--small .v-chip__content {
  width: 100%;
  justify-content: center;
}

.peregrinos-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.peregrinos-count {
  position: absolute;
  font-size: 14px;
  font-weight: bold;
  color: rgb(60, 60, 60);
  background-color: rgba(200, 200, 200, 1);
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0px;
  right: 7px;
}

.habitaciones-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.habitaciones-count {
  position: absolute;
  font-size: 12px;
  font-weight: bold;
  color: rgb(255, 255, 255);
  background-color: rgba(0, 0, 0, 1);
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: -2px;
  right: -4px;
}

.bordered-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.bordered-table ::v-deep th {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep th:last-child,
.bordered-table ::v-deep td:last-child {
  border-right: none !important;
}

/* Si también quieres líneas horizontales entre las filas */
.bordered-table ::v-deep tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

/* Si quieres un borde superior para la primera fila */
.bordered-table ::v-deep thead tr:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.tabla-filtros-row {
  background-color: #f5f5f5;
}

.tabla-filtros-row td {
  padding: 6px 4px !important;
}

.tabla-filtro-input {
  min-width: 88px;
}

.tabla-filtro-input ::v-deep .v-input__slot {
  min-height: 34px !important;
}

.v-menu__content {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.v-list-item {
  min-height: 40px;
}

.v-list-item__title {
  font-size: 14px;
}

.v-data-table ::v-deep tbody tr {
  position: relative;
}

.estado-bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  /* Ajusta este valor para cambiar el ancho de la barra */
}
</style>
